import React from "react";
import "./styles.scss";

export const ServiceNavi = () => {
    return (
        <ul className="serviceNavi">
            <li className="wetter">
                <a href="https://www.t-online.de/wetter/">Wetter</a>
            </li>
            <li>
                <a href="https://www.t-online.de/computer/browser/?tbv=04">Browser</a>
            </li>
            <li>
                <a href="https://telefonbuch.t-online.de/">Telefonverz.</a>
            </li>
            <li>
                <a
                    href="https://lotto.t-online.de/?partnerId=1DECOO0536&amp;advertisementId=1NAVIGA000000000000000000000000000000000000"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Lotto
                </a>
            </li>
            <li>
                <a href="https://tarife-und-produkte.t-online.de/">Tarife &amp; Produkte </a>
            </li>
            <li className="services">
                <span>Telekom Services</span>
                <ul>
                    <li>
                        <a href="https://www.telekom.de/start" target="_blank" rel="noopener noreferrer">
                            Telekom
                        </a>
                    </li>
                    <li>
                        <a href="https://www.telekom.de/hilfe" target="_blank" rel="noopener noreferrer">
                            Hilfe &amp; Service
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://www.telekom.de/hilfe/hilfe-bei-stoerungen/serviceassistent"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Frag Magenta
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://www.telekom.de/kundencenter/startseite"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Kundencenter
                        </a>
                    </li>
                    <li>
                        <a href="https://freemail.t-online.de/" target="_blank" rel="noopener noreferrer">
                            Freemail
                        </a>
                    </li>
                    <li>
                        <a href="https://magentacloud.de/" target="_blank" rel="noopener noreferrer">
                            MagentaCloud
                        </a>
                    </li>
                </ul>
            </li>
        </ul>
    );
};
